<div class="container">
    <div class="content">
        <h1>We're sorry</h1>
        <div class="horizontal-bar"></div>
        <h4>YOU'VE FOUND AN EMPTY BOX.</h4>

        <h4>Please try again.</h4>
        <button type="button" class="white-submit" (click)="refreshPage()">REFRESH</button>
    </div>
</div>